module.exports = __webpack_public_path__ + "static/media/elderly-care.4fa2abbc.png";